import { useCallback } from "react";

import { useModal, useConfigFile } from "@hooks";
import { isEnabledFn } from "@utils";
import FormModal from "@components/modal/FormModal";
import ActionMenuBaseItem from "@components/action_menu/item_types/ActionMenuBaseItem";

export default function ActionMenuModalItem(props) {
  const {
    modalConfigPath,
  } = props;

  const isEnabled = isEnabledFn({
    isEnabledValue: props.isEnabled,
    isDisabledValue: props.isDisabled,
    fallbackValue: true,
  });

  const isDisabled = !isEnabled;

  /**************************************************************************************************/

  const [modalConfig, isModalConfig] = useConfigFile(modalConfigPath, {
    overrides: props.modalConfig,
  });

  const modalData = props.modalData || {};

  const modal = useModal();

  /**************************************************************************************************/

  const handleClick = useCallback((_event) => {
    if (isModalConfig) {
      modal.open();
    }
  }, [modal, isModalConfig]);

  /**************************************************************************************************/

  return (
    <>
      <ActionMenuBaseItem
        onClick={handleClick}
        isDisabled={isDisabled}
        {...props}
      />
      <FormModal
        mx={modal}
        data={modalData}
        config={modalConfig}
      />
    </>
  );
}
